import React from 'react';
import styled from 'styled-components';
import Modal from 'components/UI/Modal';
import { TEXT_LABELS } from 'constants/productDetails';

const Content = styled.div``;

const RecentPromptsList = styled.div`
  background-color: white;
  border: 1px solid #e5e7eb;
  border-radius: 0.5rem;
  overflow: hidden;
  max-height: 400px;
  overflow-y: auto;
  min-height: 400px;
`;

const PromptItem = styled.div`
  padding: 12px 16px;
  border-bottom: 1px solid #e5e7eb;
  cursor: pointer;
  transition: background-color 0.2s;
  color: #374151;
  word-wrap: break-word;
  font-weight: 600;
  font-size: 14px;
  &:hover {
    background-color: #f9fafb;
  }

  &:last-child {
    border-bottom: none;
  }
`;

const EmptyState = styled.div`
  padding: 1.5rem;
  text-align: center;
  color: #9ca3af;
  font-size: 0.875rem;
`;

interface Props {
  showModal: boolean;
  onClose: () => void;
  recentPrompts: string[];
  onSelectPrompt: (prompt: string) => void;
}

export default function RecentPromptsModal({
  showModal,
  onClose,
  recentPrompts,
  onSelectPrompt,
}: Props) {
  const handlePromptSelect = (prompt: string) => {
    onSelectPrompt(prompt);
    onClose();
  };

  return (
    <Modal
      showModal={showModal}
      showCloseIcon
      width={'850px'}
      onClose={onClose}
      onClick={onClose}
      primaryButtonText={TEXT_LABELS.CONFIRM}
      ghostButtonText={TEXT_LABELS.CANCEL}
      title={TEXT_LABELS.RECENT_PROMPTS}
      modalFooterMargin="0"
      left="30%"
      showButtons={false}
      theme="accent"
    >
      <Content>
        <RecentPromptsList>
          {recentPrompts.length > 0 ? (
            recentPrompts.map((recentPrompt, index) => (
              <PromptItem
                key={index}
                onClick={() => handlePromptSelect(recentPrompt)}
              >
                {recentPrompt}
              </PromptItem>
            ))
          ) : (
            <EmptyState>{TEXT_LABELS.NO_RECENT_PROMPTS_MESSAGE}</EmptyState>
          )}
        </RecentPromptsList>
      </Content>
    </Modal>
  );
}

